import {combineReducers} from "redux";
import result from "./result";
import draw from "./draw";
const resultScReducer = combineReducers({
    result, draw
});

export default resultScReducer;
